<template>
<div>
    <Banner/>
    <div class="go-background-logo">
        <v-row justify="center" no-gutters>
            <v-col cols="11">
                <router-view ref="child"></router-view> 
            </v-col>
        </v-row>
        
    </div>
    <BottomBar :sort="parseInt($route.meta.sort)" :stage="stage" :questions_count="4" :application_id="null" :validate="validate" :submit="submit"/>
</div>

</template>
<script>
import Banner from './BannerComponent.vue'
import BottomBar from "./StageBottomBarComponent";
import Client from '../client.js';
export default {

    data: function (){
        return {
            stage: { key: 'eligibility' },
            profile: undefined,
        }
    },

    components: {
        Banner,
        BottomBar
    },
    async mounted() {

    },
    async beforeMount() {
        let client = Client();
        client.get('me/profile').then(res => {
            this.profile = res.data;
            //console.log('me/profile'+res.data);
            //console.log(res.data);
            this.prepareschool();
        }, () => {})      
    },
    methods:{
        async prepareschool(){
            if(this.profile.schoollevel == 'primary'){
                this.$store.dispatch('school/fetchAllPrimarySchools');
                this.$store.dispatch('school/fetchPrimaryPublicSchools');
                this.$store.dispatch('school/fetchPrimaryindependentSchools');
            }else if(this.profile.schoollevel == 'high'){
                this.$store.dispatch('school/fetchSchools');
                this.$store.dispatch('school/fetchActiveSchools');
            }
        },
        validate(){
            const result = this.$refs.child.validate();
            if(!result) {
                setTimeout(() => {
                    const el = document.getElementsByClassName('error--text')[0];
                    el && el.scrollIntoView({behavior: 'smooth'});
                }, 0)
            }
            return result;
        },
        submit(){
            return this.$refs.child.submit()
        },

                
    }
}
</script>
<style lang="scss" scoped>
.go-background-logo
{
    background-image: url(/go-logo-tilt.svg);
    width: 100%;
    min-height: 700px;
    background-position-y: 185px;
    background-attachment: fixed;
    background-size: 610px;
    padding-bottom: 100px;
}
</style>
